import { useState, useEffect } from "react";

const useSiteAge = (startDate) => {
  const [formattedAge, setFormattedAge] = useState([]);

  const declension = (num, one, few, many) => {
    if (num % 10 === 1 && num % 100 !== 11) return one;
    if (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)) return few;
    return many;
  };

  useEffect(() => {
    const updateAge = () => {
      const start = new Date(startDate);
      const now = new Date();
      let years = now.getFullYear() - start.getFullYear();
      let months = now.getMonth() - start.getMonth();
      let days = now.getDate() - start.getDate();
      let hours = now.getHours() - start.getHours();
      let minutes = now.getMinutes() - start.getMinutes();
      let seconds = now.getSeconds() - start.getSeconds();

      if (seconds < 0) {
        seconds += 60;
        minutes -= 1;
      }
      if (minutes < 0) {
        minutes += 60;
        hours -= 1;
      }
      if (hours < 0) {
        hours += 24;
        days -= 1;
      }
      if (days < 0) {
        const prevMonth = new Date(now.getFullYear(), now.getMonth(), 0);
        days += prevMonth.getDate();
        months -= 1;
      }
      if (months < 0) {
        months += 12;
        years -= 1;
      }

      let parts = [];
      if (years) parts.push(`${years} ${declension(years, "год", "года", "лет")}`);
      if (months) parts.push(`${months} ${declension(months, "месяц", "месяца", "месяцев")}`);
      if (days) parts.push(`${days} ${declension(days, "день", "дня", "дней")}`);
      if (hours) parts.push(`${hours} ${declension(hours, "час", "часа", "часов")}`);
      if (minutes) parts.push(`${minutes} ${declension(minutes, "минута", "минуты", "минут")}`);
      if (seconds) parts.push(`${seconds} ${declension(seconds, "секунда", "секунды", "секунд")}`);

      // Правильная вставка "и" только перед самым последним элементом
      const formatLine = (arr, isLastLine) => {
        if (arr.length > 1) {
          return isLastLine
            ? arr.slice(0, -1).join(", ") + " и " + arr[arr.length - 1]
            : arr.join(", ");
        }
        return arr.join("");
      };

      // Разделение на строки (фикс 1-2, 2-2, 3-3 и т.д.)
      const breakLines = (arr) => {
        if (arr.length === 3) return [arr[0], formatLine(arr.slice(1), true)]; // 1-2
        if (arr.length === 4) return [formatLine(arr.slice(0, 2), false), formatLine(arr.slice(2), true)]; // 2-2
        if (arr.length === 5) return [formatLine(arr.slice(0, 2), false), formatLine(arr.slice(2), true)]; // 2-3
        if (arr.length >= 6) return [formatLine(arr.slice(0, 3), false), formatLine(arr.slice(3), true)]; // 3-3
        return [formatLine(arr, true)]; // Одна строка, "и" только перед последним элементом
      };

      setFormattedAge(breakLines(parts));
    };

    updateAge();
    const interval = setInterval(updateAge, 1000);
    return () => clearInterval(interval);
  }, [startDate]);

  return formattedAge;
};

export default useSiteAge;
